import Axios from "axios"
import React, { useEffect, useState } from "react"
import { Button } from "react-bootstrap"
import { connect } from "react-redux"
import { Redirect } from "react-router"
import Select, { ValueType } from "react-select"
import AxiosConfig from "src/utilities/AxiosConfig"
import { qsStringify } from "src/utilities/helper"
import logger from '../../../utilities/logging';

interface Utility {
    UtilityName: string,
    UtilityID: number
}
interface ProfitCenter {
    ProfitCenter: string,
    ProfitCenterID: number
}
interface CallCenter {
    CallCenterName: string,
    CallCenterID: number
}
interface MemberCodeObj {
    MemberCode: string
    MemberID: number
    Utility: Utility[]
    CallCenter: CallCenter[]
    ProfitCenter: ProfitCenter[]
}
interface MemberCodeEditModalProps {
    data: MemberCodeObj
    onSubmit: () => void
    memberCodeList: string[]
    userid: number
    isNew: boolean
}
type OptionType = {
    value: string;
    label: string;
};
function MemberCodeEditModal(props: MemberCodeEditModalProps) {
    const [data, setData] = useState({
        MemberCode: props.data.MemberCode,
        MemberID: props.data.MemberID,
        Utility: JSON.parse(JSON.stringify(props.data.Utility)) as Utility[],
        CallCenter: JSON.parse(JSON.stringify(props.data.CallCenter)) as CallCenter[],
        ProfitCenter: JSON.parse(JSON.stringify(props.data.ProfitCenter)) as ProfitCenter[]
    })
    const [utilities, setUtilities] = useState([] as Utility[])
    const [profit, setProfit] = useState([] as ProfitCenter[])
    const [call, setCall] = useState([] as CallCenter[])
    const [isError, setIsError] = useState(false)
    const onSubmit = props.onSubmit
    const memberCodeList = props.memberCodeList

    //bk 9/27/2024 - bug 3193 (sort by alphebetical)
    const sort = (array: any[], key: string) => {
        return array.sort((a, b) => {
            if (a[key] < b[key]) {
                return -1
            }
            if (a[key] > b[key]) {
                return 1
            }
            return 0
        })
    }

    const getAllLists = () => {
        Axios.get(process.env.REACT_APP_API_URL + `/api/css/lists`, AxiosConfig.configValue("min"))
            .then((res) => {
                if (!res.data.error.success) {
                    throw Error(res.data.error.message)
                }
                setUtilities(sort(res.data.utilities, "UtilityName"))
                setCall(sort(res.data.call, "CallCenterName"))
                setProfit(sort(res.data.profit, "ProfitCenter"))
            })
            .catch(error => {
                alert(`There was an error getting Member Lists(${error}).`);
                //console.log(error);
                logger.Error({
                    EventMessage: `ContractMaintenance -> GetContractCustomers -> Error : ${JSON.stringify(error)}`,
                    EventCategory: "httprequest"
                });
                AxiosConfig.handleError(error);
                setIsError(true)
            })
    }
    //!!!r-18-cn
    //@ts-ignore
    const insertUtility = (y: ValueType<OptionType>) => {
        let utility = utilities.find((x) => (y as OptionType).value === x.UtilityName)
        if (utility) {
            setData({ ...data, Utility: [...data.Utility, utility] })
        }
    }
    //!!!r-18-cn
    //@ts-ignore
    const insertCalls = (y: ValueType<OptionType>) => {
        let calls = call.find((x) => (y as OptionType).value === x.CallCenterName)
        if (calls) {
            setData({ ...data, CallCenter: [...data.CallCenter, calls] })
        }
    }
    //!!!r-18-cn
    //@ts-ignore
    const insertProfit = (y: ValueType<OptionType>) => {
        let profits = profit.find((x) => (y as OptionType).value === x.ProfitCenter)
        if (profits) {
            setData({ ...data, ProfitCenter: [...data.ProfitCenter, profits] })
        }
    }
    const submitAllData = () => {
        let newMember = true
        memberCodeList.forEach((x) => {
            if (x === data.MemberCode) {
                newMember = false
            }
        })
        if (!newMember) {
            alert("Member Code already exists")
            return null;
        }
        if (data.MemberCode.length < 1) {
            alert("Invalid input")
            return null;
        }
        //insert from CallCenter, ProfitCenter, Utility
        if (data.Utility.length > 0 && data.CallCenter.length > 0 && data.ProfitCenter.length > 0) {    // if any arrays are empty, this is a delete and does not need to insert
            Axios.post(process.env.REACT_APP_API_URL + "/api/css/insert-member-code", qsStringify({
                MemberCode: data.MemberCode,
                Utilities: data.Utility.length > 0 ? data.Utility.map((x) => x.UtilityID).toString() : "[]",
                CallCenters: data.CallCenter.length > 0 ? data.CallCenter.map((x) => x.CallCenterID).toString() : "[]",
                ProfitCenters: data.ProfitCenter.length > 0 ? data.ProfitCenter.map((x) => x.ProfitCenterID).toString() : "[]",
                MemberName: data.Utility.length > 0 ? data.Utility[0].UtilityName + ' - ' + data.MemberCode : data.MemberCode,
                userID: props.userid
            }), AxiosConfig.configValue("min"))
                .then((res) => {
                    if (!res.data.error.success) {
                        alert("Unsuccessfull insert attempt")
                    }
                })
                .finally(() => onSubmit())
        }
        //delete from CallCenter, ProfitCenter, Utility
        let delCall: number[] = []
        let delProfit: number[] = []
        let delUtility: number[] = []
        props.data.CallCenter.forEach((x) => {
            if (!data.CallCenter.find((y) => y.CallCenterName === x.CallCenterName)) {
                delCall.push(x.CallCenterID)
            }
        })
        props.data.ProfitCenter.forEach((x) => {
            if (!data.ProfitCenter.find((y) => y.ProfitCenter === x.ProfitCenter)) {
                delProfit.push(x.ProfitCenterID)
            }
        })
        props.data.Utility.forEach((x) => {
            if (!data.Utility.find((y) => y.UtilityName === x.UtilityName)) {
                delUtility.push(x.UtilityID)
            }
        })
        Axios.post(process.env.REACT_APP_API_URL + "/api/css/delete-member-code", qsStringify({
            MemberCode: data.MemberCode,
            Utilities: delUtility.length > 0 ? delUtility.toString() : "[]",
            CallCenters: delCall.length > 0 ? delCall.toString() : "[]",
            ProfitCenters: delProfit.length > 0 ? delProfit.toString() : "[]",
            MemberName: data.Utility.length > 0 ? data.Utility[0].UtilityName + ' - ' + data.MemberCode : data.MemberCode,
            userID: props.userid
        }), AxiosConfig.configValue("min"))
            .then((res) => {
                if (!res.data.error.success) {
                    alert("Unsuccessfull insert attempt")
                }
            })
            .finally(() => onSubmit())
    }
    useEffect(() => {
        getAllLists()
    }, [])
    return (
        <div>
            {
                props.isNew ?
                    <div className="memberInput">
                        <div className="modalLabel">
                            <span>Member Code</span>
                        </div>
                        <input type="text" id="member" value={data.MemberCode} onChange={(e) => (setData({ ...data, MemberCode: e.target.value.toUpperCase() }))} maxLength={32} />
                    </div> :
                    <div className="memberInput">
                        <div className="modalLabel">
                            <span>Member Code:</span>
                        </div>
                        <div className="memberCodeTitle">
                            <b>{data.MemberCode}</b>
                        </div>
                    </div>
            }
            <div className="listInput">
                <div className="modalLabel">
                    <span>Utility</span>
                </div>
                <div>
                    <Select
                        placeholder="Utility List..."
                        id="select"
                        options={utilities.filter((x) => !data.Utility.find((y) => y.UtilityName === x.UtilityName)).map((x) => ({ value: x.UtilityName, label: x.UtilityName }))}
                        onChange={insertUtility}
                    />
                </div>
                <div className="dataDisplay">
                    {
                        data.Utility.map((x, index) => (
                            <span className="memberTag" key={index}>
                                {`${x.UtilityName} (${x.UtilityID})`}
                                <span className="material-icons" onClick={() => setData({ ...data, Utility: data.Utility.filter((y) => x.UtilityName !== y.UtilityName) })}>
                                    cancel
                                </span>
                            </span>
                        ))
                    }
                </div>
            </div>
            <div className="listInput">
                <div className="modalLabel">
                    <span>Call Center</span>
                </div>
                <div>
                    <Select
                        placeholder="Call Center List..."
                        id="select"
                        options={call.filter((x) => !data.CallCenter.find((y) => y.CallCenterName === x.CallCenterName)).map((x) => ({ value: x.CallCenterName, label: x.CallCenterName }))}
                        onChange={insertCalls}
                    />
                </div>
                <div className="dataDisplay">
                    {
                        data.CallCenter.map((x, index) => (
                            <span className="memberTag" key={index}>{`${x.CallCenterName} (${x.CallCenterID})`}
                                <span className="material-icons" onClick={() => setData({ ...data, CallCenter: data.CallCenter.filter((y) => x.CallCenterName !== y.CallCenterName) })}>
                                    cancel
                                </span>
                            </span>
                        ))
                    }
                </div>
            </div>
            <div className="listInput">
                <div className="modalLabel">
                    <span>Profit Center</span>
                </div>
                <div>
                    <Select
                        placeholder="Profit Center List..."
                        id="select"
                        options={profit.filter(x => !data.ProfitCenter.find(y => y.ProfitCenter === x.ProfitCenter)).map((x) => ({ value: x.ProfitCenter, label: x.ProfitCenter }))}
                        onChange={insertProfit}
                    />
                </div>
                <div className="dataDisplay">
                    {
                        data.ProfitCenter.map((x, index) => (
                            <span className="memberTag" key={index}>{`${x.ProfitCenter} (${x.ProfitCenterID})`}
                                <span className="material-icons" onClick={() => setData({ ...data, ProfitCenter: data.ProfitCenter.filter((y) => x.ProfitCenter !== y.ProfitCenter) })}>
                                    cancel
                                </span>
                            </span>
                        ))
                    }
                </div>
            </div>
            <div className="buttonSubmits">
                <Button variant="secondary" onClick={onSubmit}>Cancel</Button>
                <Button
                    variant="primary"
                    onClick={() => {
                        const confirmBox = window.confirm(
                            "Are you sure you want to save this data?"
                        )
                        if (confirmBox === true) {
                            submitAllData()
                        }
                    }}
                >Save</Button>
            </div>
            {
                isError ?
                    <Redirect to="/css/member-code-maintenance" /> : null
            }
        </div>
    )
}
const mapStateToProps = (state: any) => ({
    username: state.user.userName,
    userid: state.user.userId
})
export default connect(mapStateToProps)(MemberCodeEditModal)